var drawHighChartLine = {
	drawLine:function(id,ydata,xdata,Highcharts){
		var max = Math.max.apply(null,ydata);
		var colorArr,currentIndex,currentValue,currentColor;
		var xData2=[],xData1=[];
		var secondData;
		xdata.forEach(function(item,index){
			var dateArr = item.split('\n');
			if(dateArr.length>=2){
				secondData=dateArr[1]
				xData2.push(dateArr[0])
				xData1.push(dateArr[1])
			}else{
				xData2.push(dateArr[0])
				xData1.push(secondData)
			}
		});
		var transformData=[];
		var flag = true;

		if (max<=25) {
			colorArr=['#38c99e','#38c99e','#38c99e','#38c99e'];
		} else if (max<=50) {
			colorArr=['#38c99e','#f2e838','#f2e838','#f2e838'];
		} else if (max<=75) {
			colorArr=['#38c99e','#f2e838','#ffa500','#ffa500'];
		} else {
			colorArr=['#38c99e','#f2e838','#ffa500','#ff0000'];
		} 
		
		ydata.forEach(function(item,index){
			var currentDate = new Date();
			var month = currentDate.getMonth() + 1;
			var date = currentDate.getDate();
			var hour = currentDate.getHours();
			if (month < 10) {
				month = '0' + month;
			}
			var date = currentDate.getDate();
			if (date < 10) {
				date = '0' + date;
			}
			var date1 = month + '-' + date;

			var timeArr = xData1[index].split(':');
			var tempHour = parseInt(timeArr[0].slice(0,1) === '0'?timeArr[0].slice(1,2):timeArr[0]);
			if (date1 === xData2[index] && tempHour >= hour && flag) {
				currentIndex=index;
			}else{
				currentIndex=1;
			}
		});
		
		if (ydata[currentIndex]<=25) {
			currentColor='#38c99e';
		} else if (ydata[currentIndex]<=50) {
			currentColor='#f2e838';
		} else if (ydata[currentIndex]<=75) {
			currentColor='#ffa500';
		} else {
			currentColor='#ff0000';
		} 
		//console.info(transformData)
		var chart = Highcharts.chart(id, {
			chart: {
				type: 'areaspline',
	            backgroundColor:'rgba(0,0,0,0)',
	            marginTop:10,
	            marginLeft:28,
	            marginRight:-24,
	            marginBottom:50
	        },
		    title: {
		        text: ''
		    },
		    yAxis: {
		    	gridLineColor: '#e6e4e4',
	            gridLineWidth: 0,
	            gridLineDashStyle: 'ShortDash',
	            //tickInterval:30,
	            tickPositions: [0, 20, 60, 100,120],
		        title: {
		            text: '',
		            enabled: false,
		        },
		        enabled: false,
		        max:120, // 定义Y轴 最大值    
        		min:0, // 定义最小值
		    },
		    xAxis: [{
	        	categories:xdata,
	        	tickmarkPlacement: 'on',
	            gridLineColor: '#c3d7eb',
	            gridLineWidth: 0 ,
	            lineWidth: 1,//基线宽度 
	            tickColor: '#c3d7eb',
	            //tickWidth: 0,
	            tickLength:3,
	            showLastLabel: false,
	            labels: {
	            	align: 'left',
	            	y:15,
	            	x:-3,
					//对横坐标刻度值进行格式化
					formatter: function() {
						if(this.value.indexOf('\n')>0){
							return this.value.split('\n')[0]+'<br/>'+this.value.split('\n')[1]
						}else{
							return this.value
						}
					}
				}
	        }],
		    legend:{
		    	enabled:false
		    },
		    tooltip: {
		    	enabled:false,
		    	followPointer:false,
		    	followTouchMove:false,
		    	borderColor:currentColor,
		    	backgroundColor:'#fff',
		    	shadow:false,
	            formatter: function () {
	            	var value = this.y
	            	if (value<=25) {
	            		value += " 无"
	            	} else if (value<=50) {
	            		value += " 轻度"
	            	} else if (value<=75){
	            		value += " 中度"
	            	} else {
	            		value += " 重度"
	            	}
	            	return value
                },
                style: {
	                padding: 5,
	                fontWeight: 'bold',
	                fontSize:'14',
	                color:currentColor
	            }
	        },
	        credits: {
	            enabled: false
	        },//隐藏highchair水印
	        exporting: {
	            enabled:false
			},//隐藏右上角的打印及其导出按钮
		    plotOptions: {
	        	enableMouseTracking: false,
	            areaspline: {
	                color:'rgba(133,219,255,1)',  
	                lineColor:'rgba(255,255,255,0)', 
	                lineWidth:0,
	                fillColor: { //曲线图背景颜色
	                        linearGradient: {
	                            x1: 0,
	                            y1: 0,
	                            x2: 0,
	                            y2: 1
	                        },
	                        stops: [
	                            [0, Highcharts.Color(colorArr[3]).setOpacity(1).get('rgba')], 
	                            [0.333, Highcharts.Color(colorArr[2]).setOpacity(0.9).get('rgba')],
	                            [0.666, Highcharts.Color(colorArr[1]).setOpacity(0.7).get('rgba')],
	                            [1, Highcharts.Color(colorArr[0]).setOpacity(0.6).get('rgba')]  
	                        ]
	                    }, 
	            }
	        },
		    series: [{
		        data: ydata,
		        lineWidth:1,
		        lineColor: '#38c99e',
	            marker: {
	                symbol: 'circle',
	                fillColor: '#85dbff',//点填充色
	                radius:0,
	                //lineWidth: 2,
	                lineColor: '#85dbff',//点边框色
	            },
	            cursor: 'pointer',
	            states: {
			      hover: {
			        enabled: false
			      }
			    }
		    }],
		    responsive: {
		        rules: [{
		            condition: {
		                maxWidth: 500
		            },
		            chartOptions: {
		                legend: {
		                    // layout: 'horizontal',
		                    // align: 'center',
		                    // verticalAlign: 'bottom'
		                }
		            }
		        }]
		    }
		});
		chart.tooltip.refresh(chart.series[0].data[currentIndex]);
	}
}
export default drawHighChartLine;


// WEBPACK FOOTER //
// ./src/components/util/drawHighChartLine.js